import { GuideQueueContext } from '@rhg/providers/guide-queue';
import { useContext } from 'react';

export const useGuideQueue = () => useContext(GuideQueueContext);
